let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cyfpE")).then(() => parcelRequire('7XuGk'));